import { useState, useEffect } from 'react';
import { Snackbar, Alert } from '@mui/material';
import { notificationBus } from '../../api/notificationBus';
import { motion } from "framer-motion";
import { toastVariants } from '../../utils/animations';

const GlobalSnackbar = () => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState('error');

  useEffect(() => {
    return notificationBus.subscribe(({ message, severity }) => {
      setMessage(message);
      setSeverity(severity);
      setOpen(true);
    });
  }, []);

  return (
    <Snackbar open={open} autoHideDuration={4000} onClose={() => setOpen(false)}>
      <motion.div variants={toastVariants} initial="initial" animate="animate">
        <Alert severity={severity} onClose={() => setOpen(false)}>
        {message}
      </Alert>
      </motion.div>
    </Snackbar>
  );
};

export default GlobalSnackbar;
